import {Types}  from "../actions/videoActions";
import _ from "lodash";

const defaultState = {
  video: {}
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {


    case Types.VIDEO_MODAL: {

      const newState = {...state};

      newState.video.modal = action.status
      
      return newState;
    }


    default:
      return state;
  }
};

export default reducer;